import { memo } from 'react';
import { cn } from '@divlab/divanui';

import H2 from '@Components/H2';
import styles from './ConditionsToBuyInCredit.module.css';

import type { ConditionCreditData } from '@Pages/PageCredit/typings';
import type { FC, HTMLAttributes } from 'react';

export interface ConditionsToBuyInCreditProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  page: ConditionCreditData;
}

const ConditionsToBuyInCredit: FC<ConditionsToBuyInCreditProps> = (props) => {
  const { className, page, ...restProps } = props;
  const isFullWidth = page.list.length > 2;

  return (
    <div {...restProps} className={cn(styles.conditionsToBuyInCredit, className)}>
      <H2 title={page.text.text} className={styles.title} />

      <div className={cn(styles.wrapper, { [styles.alignStart]: !isFullWidth })}>
        {page.list.map((item) => (
          <div key={item.text} className={styles.condition}>
            {!!item.image && (
              <img className={cn(styles.icon, styles[item.image.id])} src={item.image.src} />
            )}
            <div className={styles.text}>{item.text}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default memo(ConditionsToBuyInCredit);
